import React from 'react';
import MarketingDetailPage from './MarketingDetailPage';
import { EMAIL_CONFIG } from '../constants/marketingEmailColumnsConfig';

function ReportingMarketingEmailPage({ team, csrfToken, currentUser, venueOwnerships }) {
  return (
    <MarketingDetailPage
      team={team}
      csrfToken={csrfToken}
      venueOwnerships={venueOwnerships}
      config={EMAIL_CONFIG}
    />
  );
}

export default ReportingMarketingEmailPage;
